import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=9007385e&scoped=true"
import script from "./supplierList.vue?vue&type=script&lang=js"
export * from "./supplierList.vue?vue&type=script&lang=js"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=9007385e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9007385e",
  null
  
)

export default component.exports